import { Record } from "immutable";
import { generatePath } from "react-router";

import { ROUTES } from "@config/app.routing";

import { ProfileContract } from "@typings/profileContracts";
import { Job } from "@typings/jobs";

export const getChecklistParams = (
  data: Record<ProfileContract> | Record<Job>,
): {
  contractUuid: string;
  isCreated: boolean;
  hasOnboardingCompleted: boolean;
  hasSpecialInstructions: boolean;
} => {
  const contractUuid = data.get<string>("contractUuid", "");

  const cleaningChecklist = data.get<
    Job["cleaningChecklist"] | ProfileContract["cleaningChecklist"] | undefined
  >("cleaningChecklist", undefined);

  const hasOnboardingCompleted = data.get<boolean>(
    "hasOnboardingCompleted",
    false,
  );

  let isCreated = false;

  if (Record.isRecord(cleaningChecklist)) {
    isCreated = (cleaningChecklist as Job["cleaningChecklist"]).get(
      "isCreated",
      false,
    );
  } else {
    isCreated = (cleaningChecklist as ProfileContract["cleaningChecklist"])
      .isCreated;
  }

  let hasSpecialInstructions = false;

  if (data.has("hasSpecialInstructions")) {
    hasSpecialInstructions = data.get<
      ProfileContract["hasSpecialInstructions"]
    >("hasSpecialInstructions", false);
  }

  if (data.has("specialInstructions")) {
    hasSpecialInstructions = !!data.get<Job["specialInstructions"]>(
      "specialInstructions",
      null,
    );
  }

  return {
    contractUuid,
    isCreated,
    hasOnboardingCompleted,
    hasSpecialInstructions,
  };
};

export const computeUrl = (
  data: Record<ProfileContract> | Record<Job>,
): string => {
  let checklistUrl = `${ROUTES.CLIENT_DASHBOARD}${ROUTES.CLIENT_CHECKLIST}`;

  const { hasOnboardingCompleted, contractUuid, isCreated } =
    getChecklistParams(data);

  checklistUrl = generatePath(checklistUrl, {
    contractUuid,
    variant: isCreated ? "edit" : "create",
  });

  if (!hasOnboardingCompleted) {
    checklistUrl += ROUTES.CLIENT_CHECKLIST_ONBOARDING;
  }

  return checklistUrl;
};
